import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { editWebpage } from 'action/webpage'
import { Form, Modal } from 'antd'
import PropTypes from 'prop-types'
import WebpageForm from 'view/page/webpage-management/component/webpage-form'
import FormModal from 'view/component/form-modal'
import * as NUMBER from 'constant/number'
import _ from 'lodash'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: `${response.title} has been successfully edited${response.is_draft ? ' and saved as a draft.' : '.'}`,
  title: 'Webpage edited'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const EditWebpage = ({ webpage, editWebpage, submitting }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()

  const handleClick = () => setVisible(true)

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const response = await editWebpage({ ...values, uuid: webpage.uuid })
      setVisible(false)
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }
  webpage.category_uuid = _.compact(webpage.category_uuid)
  return (
    <>
      <a onClick={handleClick}>Edit Webpage</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.setFieldsValue(webpage)
        }}
        title='Edit Webpage'
        visible={visible}
      >
        <WebpageForm
          form={form}
          webpage={webpage}
        />
      </FormModal>
    </>
  )
}

EditWebpage.propTypes = {
  editWebpage: PropTypes.func,
  submitting: PropTypes.bool,
  webpage: PropTypes.object
}

const mapStateToProps = (state) => ({
  submitting: state.loader.webpageSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  editWebpage: bindActionCreators(editWebpage, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EditWebpage)
